import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirects)/fleet/members')({
  component: () => <Navigate to="/enterprise" />,
});
